
import { IonButton, IonCol, IonContent, IonGrid, IonPage, IonRow, IonText, useIonViewWillEnter } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Chart from '../components/Chart';
import Feeds from '../components/Feeds';
import Footer from '../components/Footer';
import { Account, User } from '../models/data';
import { translation } from '../models/translation';
import { fetchUserBalance_b, fetchUserDonations } from '../services/donate_service';
import { fetchUserFeeds } from '../services/feed_service';
import LanguagePack from '../services/translations';


interface Props {
  user: User,
  account: Account
}
// make user dynamic // 
const DashbordHome: React.FC<Props> = (props) => {

  useIonViewWillEnter(() => {
    fetchDonationsData();
    fetchCurrentUserBalance();
  })

  const location = useLocation().pathname;




  /**Translation kit */
  const siteStrings: LanguagePack = new LanguagePack()

  /**get text stings for page */
  const homeTranslations = siteStrings.getHomeTranslations('fr');

  const siteText = translation();


  /**Initatiate feeds state */
  const [feeds, setFeeds] = useState<any>();
  const [donations, setDonations] = useState<any>(null);
  const [balance, setBalance] = useState<any>()

  /**Define view name */
  const name = homeTranslations.homeTitle;

  /**Get donatation date */


  /**Get Feed Data */
  useEffect(() => {
    fetchFeedsData();
  }, [])


  /**fetch feeds data fuction() */
  const fetchFeedsData = async () => {
    let data = await fetchUserFeeds(props.account.feeds);
    if (!data.error) {
      setFeeds(data.message)
    } else {
      setFeeds(data.error)
    }

  }

  /** */
  const fetchDonationsData = async () => {
    let data = await fetchUserDonations(props.user.id);
    if (!data.error) {
      let allDonations = data.message;
      let completedDonations: any = [];
      allDonations.forEach((item: any) => {
        if (item.acf.status === "completed") {
          completedDonations.push(item)
          return
        }
      })

      setDonations(completedDonations);
    } else {
      setDonations(data.error)
    }
  }

  /** */
  const fetchCurrentUserBalance = async () => {

    await fetchUserBalance_b(props.user.id).then(
      m => {
        if (!m?.error) {
          setBalance(m?.message)
        }
      }
    );

  }



  return (
    <IonPage>
      <IonContent>
        <IonGrid className='innerBody'>
          <IonRow className='sw_sp_lg'>
            <IonCol sizeSm='10' offsetSm='1' className='titlebar big ion-text-center '>
              {/*<h1>{name}</h1>*/}
              <h1> {siteText.accountHomeWelcomeTxt.replace('%%name%%', props.user.firstName!)}</h1>
              {/*<p>Your current balance is</p>*/}
              <IonButton className='ion-margin-top' strong size='large' routerLink='./donate' routerDirection='forward' shape="round">
                <IonText color='light'>
                  {siteText.accountHomePrimaryActionTxt}
                </IonText>
              </IonButton>
            </IonCol>
            <IonCol size='12' className='ion-text-center ion-padding-top'>
              {siteText.accountHomeCreditStatement.replace('%%amount%%', balance)}
            </IonCol>
          </IonRow>
          <IonRow className='ion-padding'>
            <IonCol>
              <h2 className='ion-padding'>{siteText.accountHomeSummaryTitle}</h2>
              {!donations ? '' : <Chart data={donations}></Chart>}
            </IonCol>
          </IonRow>
          <IonRow className='ion-padding'>
            <IonCol>
              <h2 className='ion-padding'>{siteText.accountHomeFeedTitle}</h2>
              <Feeds feeds={feeds}></Feeds>
            </IonCol>
          </IonRow>
        </IonGrid>
        <Footer></Footer>
      </IonContent>
    </IonPage>
  )
}

export default DashbordHome;